/**
 * LERA Featured Products Premium — Sprint 8.8
 * Loads Shopify Product Recommendations for Related / Recommendations sources only.
 */

(function () {
  const BODY = '[data-lera-fp-recs-url]';

  function loadBlockRecommendations(body) {
    if (!body || body.dataset.leraFpRecsFetch === '1') return;
    const url = body.getAttribute('data-lera-fp-recs-url');
    const blockId = body.getAttribute('data-lera-fp-block-id');
    if (!url || !blockId) return;

    body.dataset.leraFpRecsFetch = '1';

    const run = () => {
      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error('Recommendations request failed');
          return response.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const next = doc.querySelector(`[data-lera-fp-block-id="${blockId}"]`);
          if (!next) return;

          const nextHasCards = Boolean(next.querySelector('.lera-product-card, .lera-product-grid__item'));
          if (!nextHasCards && !body.querySelector('.lera-product-grid__item')) {
            const block = body.closest('.featured-products-premium__block');
            block?.remove();
            return;
          }

          if (nextHasCards) {
            body.replaceWith(next);
          } else {
            body.removeAttribute('data-lera-fp-recs-pending');
          }
        })
        .catch(() => {
          body.dataset.leraFpRecsFetch = '0';
        });
    };

    if (!('IntersectionObserver' in window)) {
      run();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0]?.isIntersecting) return;
        observer.disconnect();
        run();
      },
      { rootMargin: '0px 0px 320px 0px' }
    );

    observer.observe(body);
  }

  function boot(root) {
    const scope = root || document;
    scope.querySelectorAll(BODY).forEach(loadBlockRecommendations);
  }

  function onReady() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', (event) => {
    boot(event.target);
  });

  window.LeraFeaturedProductsPremium = window.LeraFeaturedProductsPremium || {
    version: '8.8',
    refresh: onReady,
  };
})();
